@if (!disabled) {
  <button data-ripple-light="true" [style]="class">
    <div class="flex items-center justify-center">
      @if (faIcon != null) {
        <fa-icon class="mr-1" [icon]="faIcon" />
      }
      {{text}}
    </div>
  </button>
}
@if (disabled) {
  <button data-ripple-light="true" [class]="disabledClass" disabled>
    @if (faIcon != null) {
      <div class="flex items-center justify-center">
        @if (faIcon != null) {
          <fa-icon class="mr-1" [icon]="faIcon" />
        }
        {{text}}
      </div>
    }
    @if (faIcon == null) {
      <div class="text-center">
        {{text}}
      </div>
    }
  </button>
}
